import { render, staticRenderFns } from "./salesorderbycampaign.vue?vue&type=template&id=081d48e8"
import script from "./salesorderbycampaign.vue?vue&type=script&lang=js"
export * from "./salesorderbycampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports